<template>
    <div>
        <b-container fluid>
            <b-row class="mb-1">
                <b-col>
                    <app-barcode-scanner v-model="person" ref="barcodeScanner" />
                </b-col>
            </b-row>
            <b-row v-if="!!person">
                <b-col cols="12" lg="10" offset-lg="1">
                    <b-btn variant="primary" @click="shouldUpdatePhoto = !shouldUpdatePhoto"><i class="fa fa-camera"></i> Actualizar Foto</b-btn>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="12" lg="10" offset-lg="1">
                    <div v-if="type === 'IN' && !!personEntry">
                        <b-row no-gutters>
                            <b-col>
                                <b-alert variant="success" show>
                                    <h3>
                                        (INGRESO) {{ dayPart }} {{ person.name }}
                                    </h3>
                                </b-alert>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <app-person-entry-card :person-entry="personEntry" />
                            </b-col>
                        </b-row>
                    </div>
                    <div v-if="type === 'OUT' && !!personDeparture">
                        <b-row no-gutters>
                            <b-col>
                                <b-alert variant="warning" show>
                                    <h3>
                                        (SALIDA) Hasta luego
                                    </h3>
                                </b-alert>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <app-person-departure-card :person-departure="personDeparture" />
                            </b-col>
                        </b-row>
                    </div>
                </b-col>
            </b-row>        
        </b-container>
            <app-person-update-photo v-if="!!person" v-model="shouldUpdatePhoto" :person="person" @on-update="personPhotoUpdated" />
    </div>
</template>
<script>
import BarcodeScanner from '../../../../UI/Controls/BarcodeScanner/BarcodeScanner';
import vigilanceRepository from '../../../../../repositories/vigilance.repository';
import PersonEntryCard from '../../../../UI/Vigilance/PersonEntryCard/PersonEntryCard';
import PersonDepartureCard from '../../../../UI/Vigilance/PersonDepartureCard/PersonDepartureCard';
import {mapActions, mapMutations, mapGetters} from 'vuex';
import * as actions from '../../../../../store/actionTypes';
import PersonUpdatePhoto from '../../../../Clients/PersonUpdatePhoto/PersonUpdatePhoto';

export default {
    components: {
        appBarcodeScanner: BarcodeScanner,
        appPersonEntryCard: PersonEntryCard,
        appPersonDepartureCard: PersonDepartureCard,
        appPersonUpdatePhoto: PersonUpdatePhoto
    },
    data: () => ({
        person: '',
        personEntry: '',
        personDeparture: '',
        type: '',
        personPhotos: '',
        shouldUpdatePhoto: false
    }),
    watch: {
        person(val) {
            if(!val.document || !val.name) return;
            this.tryPersonEntry(val);
        }
    },
    computed: {
        ...mapGetters(['personEntries']),
        dayPart() {
            const now = moment();
            const hour = parseInt(now.format('HH'));
            const part = hour >= 0 && hour < 12
                ? 'BUENOS DÍAS'
                : hour >= 12 && hour < 19
                    ? 'BUENAS TARDES'
                    : 'BUENAS NOCHES';

            return part;
        }
    },
    methods: {
        ...mapActions({
            closePersonEntry: actions.CLOSE_PERSON_ENTRY
        }),
        ...mapMutations({
            setPersonEntries: 'personEntries'
        }),
        async tryPersonEntry(thePerson) {
            const vr = {...vigilanceRepository};
            try {
                const {data} = await vr.tryPersonEntry(thePerson, this.client.id, this.accessPoint.id, this.user.id);
                this.$refs.barcodeScanner.stopReading();

                // Si el estado de la operación es falso ocurrió un error inesperado
                const {status, personEntry, personDeparture, msg, type, person} = data;
                if(!status) return toastr.error(`Ocurrió un error al registrar el ingreso [${msg}]`);

                

                this.type = type;
                if(type === 'IN') {
                    if(!personEntry){
                        // la operación es satisfactoria pero no se creo el ingreso es porque es un usuario externo que se debe autorizar
                        return this.$emit('start-entry', person.document.toString());
                    } else {
                        this.personEntry = personEntry;
                        // Cargar los ingresos
                        this.$store.dispatch('entries');
                    }
                } else {
                    this.personDeparture = personDeparture;

                    this.closePersonEntry(personDeparture.person_entry_id);
                }
                this.person = thePerson;


            } catch(err) {
                toastr.error('Ocurrió un error intentando ingresar los datos de la personas');
            }
        },
        personPhotoUpdated(photoUrl) {
            // this.person.photo = photoUrl;
            if(!this.personEntry) return;

            const personEntries = [...this.personEntries];
            const index = personEntries.findIndex(item => item.id === this.personEntry.id);

            if(-1 === index) return;

            const newPersonEntry = {...personEntries[index]};
            newPersonEntry.person.photo = photoUrl;

            this.setPersonEntries(personEntries.splice(index, 1, newPersonEntry));

        },
        reset() {
            this.person = '';
            this.personEntry = '';
            this.personDeparture = '';
            this.type = '';
            this.personPhotos = '';
            this.shouldUpdatePhoto = false;
        }
    },
    created() {
        //this.$barcodeScanner.init(this.readCode);
        this.$bus.$on('barcode-reader.clear', this.reset);
    },
    mounted() {
        //this.$refs.codeField.focus();
        this.reset();
    },
    beforeDestroy () {
        this.$bus.$off('barcode-reader.clear');
        // Remove listener when component is destroyed
        //this.$barcodeScanner.destroy()
    }
}
</script>